// import { useState } from 'react'
// import { useParams, useNavigate } from 'react-router-dom'
// import { motion } from 'framer-motion'
// import { Clock, Award, ChevronDown, ChevronUp, Lock, CheckCircle, Headphones, MessageCircle, BookOpen, Users, Star, Play, Crown, Zap, Target, BarChart3, Sparkles, Mic, Download, Share2, ChevronLeft } from 'lucide-react'
// import ProgressTracker from '../components/ProgressTracker'
// import { courses, podcasts } from '../data/mockData'
// import useStore from '../store/useStore'
// import Toast from '../components/Toast'

// function CourseDetail() {
//   const { id } = useParams()
//   const navigate = useNavigate()
//   const course = courses.find((c) => c.id === parseInt(id))
//   const { 
//     enrolledCourses, 
//     enrollInCourse, 
//     markLessonComplete, 
//     completedLessons, 
//     accessTier, 
//     user, 
//     setCurrentlyPlaying,
//     completeLessonWithPoints 
//   } = useStore()
//   const [expandedModules, setExpandedModules] = useState([])
//   const [pointsEarned, setPointsEarned] = useState(0)
//   const [showPointsNotification, setShowPointsNotification] = useState(false)

//   if (!course) {
//     return (
//       <div className="min-h-screen bg-gray-50 flex items-center justify-center">
//         <div className="text-center">
//           <h2 className="text-2xl font-bold text-gray-900 mb-4">Course Not Found</h2>
//           <button onClick={() => navigate('/courses')} className="btn-primary">
//             Back to LearningHub
//           </button>
//         </div>
//       </div>
//     )
//   }

//   // Find related podcast for this course
//   const relatedPodcast = podcasts.find(podcast => podcast.relatedCourseId === course.id)

//   const isEnrolled = enrolledCourses.includes(course.id)
//   const courseLessons = completedLessons[course.id] || []
//   const authenticated = !!user

//   const canAccess = () => {
//     if (course.tier === 'free') return true
//     if (course.tier === 'premium' && (accessTier === 'plus' || accessTier === 'pro' || accessTier === 'business' || accessTier === 'premium_access')) return true
//     if (course.tier === 'scholarship' && (accessTier === 'pro' || accessTier === 'business' || accessTier === 'premium_access')) return true
//     return false
//   }

//   const hasAccess = canAccess()
//   const canEnroll = authenticated && hasAccess

//   const toggleModule = (moduleId) => {
//     setExpandedModules((prev) =>
//       prev.includes(moduleId)
//         ? prev.filter((id) => id !== moduleId)
//         : [...prev, moduleId]
//     )
//   }

//   const handleEnroll = () => {
//     if (!authenticated) {
//       navigate('/auth')
//       return
//     }

//     if (!hasAccess) {
//       if (course.tier === 'premium') {
//         alert('Please upgrade to Saints Plus to access this course')
//         navigate('/pricing')
//       } else {
//         alert('Please upgrade to Saints Pro or apply for Ambassador Program to access this course')
//         navigate('/ambassador-program')
//       }
//       return
//     }

//     enrollInCourse(course.id)
//   }

//   const handleStartCourse = () => {
//     if (!authenticated) {
//       navigate('/auth')
//       return
//     }

//     if (!isEnrolled) {
//       handleEnroll()
//     }
    
//     // Navigate to first lesson
//     const firstModule = course.modules[0]
//     const firstLesson = firstModule.lessons[0]
//     navigate(`/learning-path/${getLearningPathIdForCourse()}`)
//   }

//   const getLearningPathIdForCourse = () => {
//     // Map course to learning path - in real app, this would come from backend
//     const courseToPathMap = {
//       101: 1, // AI Course -> AI Learning Path
//       102: 1, // Neural Networks -> AI Learning Path  
//       103: 2, // React -> Web Dev Path
//       104: 3, // Startup -> Entrepreneurship Path
//       105: 3, // Marketing -> Entrepreneurship Path
//       106: 4, // UI/UX -> Creative Path
//       107: 4, // Music -> Creative Path
//       108: 5, // Productivity -> Personal Dev Path
//       109: 6, // Space -> Science Path
//       110: 7  // Nutrition -> Health Path
//     }
//     return courseToPathMap[course.id] || 1
//   }

//   const getTierDisplayName = (tier) => {
//     const tierMap = {
//       'free': 'Saints Free',
//       'premium': 'Saints Plus', 
//       'scholarship': 'Saints Pro'
//     }
//     return tierMap[tier] || tier
//   }

//   const getTierColor = (tier) => {
//     const colorMap = {
//       'free': 'from-gray-600 to-gray-800',
//       'premium': 'from-green-500 to-green-700',
//       'scholarship': 'from-purple-500 to-purple-700'
//     }
//     return colorMap[tier] || 'from-gray-600 to-gray-800'
//   }

//   const getCourseImage = (courseId) => {
//     const courseImages = {
//       101: 'https://images.unsplash.com/photo-1555949963-aa79dcee981c?w=800&h=400&fit=crop', // AI
//       102: 'https://images.unsplash.com/photo-1635070041078-e363dbe005cb?w=800&h=400&fit=crop', // Neural Networks
//       103: 'https://images.unsplash.com/photo-1633356122544-f134324a6cee?w=800&h=400&fit=crop', // React
//       104: 'https://images.unsplash.com/photo-1556761175-b413da4baf72?w=800&h=400&fit=crop', // Startup
//       105: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=800&h=400&fit=crop', // Marketing
//       106: 'https://images.unsplash.com/photo-1561070791-2526d30994b5?w=800&h=400&fit=crop', // UI/UX
//       107: 'https://images.unsplash.com/photo-1571974599782-87624638275f?w=800&h=400&fit=crop', // Music
//       108: 'https://images.unsplash.com/photo-1543286386-713bdd548da4?w=800&h=400&fit=crop', // Productivity
//       109: 'https://images.unsplash.com/photo-1446776877081-d282a0f896e2?w=800&h=400&fit=crop', // Space
//       110: 'https://images.unsplash.com/photo-1490645935967-10de6ba17061?w=800&h=400&fit=crop'  // Nutrition
//     }
//     return courseImages[courseId] || 'https://images.unsplash.com/photo-1501504905252-473c47e087f8?w=800&h=400&fit=crop'
//   }

//   const totalLessons = course.modules.reduce((sum, module) => sum + module.lessons.length, 0)
//   const completedCount = courseLessons.length
//   const progress = totalLessons > 0 ? Math.round((completedCount / totalLessons) * 100) : 0

//   const handlePlayPodcast = () => {
//     if (relatedPodcast) {
//       setCurrentlyPlaying(relatedPodcast)
//     }
//   }

//   const handleLessonComplete = async (courseId, lessonId) => {
//     const earnedPoints = await completeLessonWithPoints(courseId, lessonId, course);
//     if (earnedPoints > 0) {
//       setPointsEarned(earnedPoints);
//       setShowPointsNotification(true);
//       setTimeout(() => setShowPointsNotification(false), 3000);
//     }
//   }

//   return (
//     <div className="min-h-screen bg-gray-50">
//       {/* Points Notification */}
// <Toast 
//   message="Great progress!"
//   points={pointsEarned}
//   type="points"
//   isVisible={showPointsNotification}
//   onHide={() => setShowPointsNotification(false)}
// />

//       {/* Enhanced Hero Section with Image */}
//       <section className={`bg-gradient-to-br ${getTierColor(course.tier)} text-white py-12 relative overflow-hidden`}>
//         {/* Background Image with Overlay */}
//         <div className="absolute inset-0">
//           <img 
//             src={getCourseImage(course.id)} 
//             alt={course.title}
//             className="w-full h-full object-cover"
//           />
//           <div className="absolute inset-0 bg-black/50"></div>
//         </div>
        
//         <div className="relative max-w-7xl mx-auto px-4 sm:px-6">
//           {/* Back to LearningHub Button */}
//           <button
//             onClick={() => navigate('/courses')}
//             className="flex items-center space-x-2 text-white/80 hover:text-white mb-6 transition-colors duration-200"
//           >
//             <ChevronLeft className="w-5 h-5" />
//             <span>Back to LearningHub</span>
//           </button>

//           <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
//             <div className="lg:col-span-2">
//               <div className="flex items-center space-x-3 mb-4">
//                 <span className="text-sm font-medium text-white/80 bg-white/20 backdrop-blur-sm px-3 py-1 rounded">
//                   {course.category}
//                 </span>
//                 <div className="flex items-center space-x-1">
//                   <Star className="w-4 h-4 text-yellow-300 fill-current" />
//                   <span className="text-sm font-bold">{course.rating}</span>
//                   <span className="text-sm text-white/60">({Math.floor(course.students / 100)} reviews)</span>
//                 </div>
//               </div>
              
//               <h1 className="text-3xl md:text-4xl font-bold mb-4">{course.title}</h1>
//               <p className="text-lg text-white/90 mb-6">{course.description}</p>
              
//               <div className="flex flex-wrap gap-6 mb-6">
//                 <div className="flex items-center space-x-2">
//                   <BookOpen className="w-5 h-5 text-yellow-300" />
//                   <span>{totalLessons} lessons</span>
//                 </div>
//                 <div className="flex items-center space-x-2">
//                   <Clock className="w-5 h-5 text-yellow-300" />
//                   <span>{course.duration}</span>
//                 </div>
//                 <div className="flex items-center space-x-2">
//                   <Users className="w-5 h-5 text-yellow-300" />
//                   <span>{course.students.toLocaleString()} students</span>
//                 </div>
//                 {course.hasCertificate && (
//                   <div className="flex items-center space-x-2">
//                     <Award className="w-5 h-5 text-yellow-300" />
//                     <span>Certificate included</span>
//                   </div>
//                 )}
//               </div>

//               {/* Action Buttons */}
//               <div className="flex flex-col sm:flex-row gap-4">
//                 {!isEnrolled ? (
//                   <button
//                     onClick={handleEnroll}
//                     className="flex items-center space-x-3 px-8 py-4 bg-white text-gray-900 rounded-xl font-semibold hover:shadow-xl transition-all duration-200"
//                   >
//                     <Play className="w-6 h-6" />
//                     <span>Enroll Now</span>
//                   </button>
//                 ) : (
//                   <button
//                     onClick={handleStartCourse}
//                     className="flex items-center space-x-3 px-8 py-4 bg-white text-gray-900 rounded-xl font-semibold hover:shadow-xl transition-all duration-200"
//                   >
//                     <Play className="w-6 h-6" />
//                     <span>{progress > 0 ? 'Continue Learning' : 'Start Learning'}</span>
//                   </button>
//                 )}
//                 <button
//                   onClick={() => navigate('/courses')}
//                   className="flex items-center space-x-3 px-8 py-4 bg-white/20 backdrop-blur-sm text-white rounded-xl font-semibold hover:bg-white/30 transition-all duration-200"
//                 >
//                   <span>Browse More Courses</span>
//                 </button>
//               </div>
//             </div>

//             {/* Course Access Card */}
//             <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20">
//               <div className={`text-center py-4 px-6 rounded-lg mb-4 bg-gradient-to-r ${getTierColor(course.tier)}`}>
//                 <p className="text-sm font-medium opacity-90">Required Tier</p>
//                 <p className="text-2xl font-bold mt-1">{getTierDisplayName(course.tier)}</p>
//               </div>
              
//               {!hasAccess ? (
//                 <div className="space-y-4">
//                   <div className="text-center">
//                     <Lock className="w-12 h-12 text-white/60 mx-auto mb-3" />
//                     <p className="text-white/80 mb-4">
//                       {course.tier === 'premium' 
//                         ? 'Upgrade to Saints Plus to unlock this course' 
//                         : 'Upgrade to Saints Pro to unlock this course'
//                       }
//                     </p>
//                   </div>
//                   <button
//                     onClick={() => navigate('/pricing')}
//                     className="w-full py-3 bg-white text-gray-900 rounded-lg font-semibold hover:bg-white/90 transition-colors duration-200"
//                   >
//                     View Subscription Plans
//                   </button>
//                   <button
//                     onClick={() => navigate('/ambassador-program')}
//                     className="w-full py-3 bg-yellow-400 text-gray-900 rounded-lg font-semibold hover:bg-yellow-300 transition-colors duration-200"
//                   >
//                     Apply for Ambassador Program
//                   </button>
//                 </div>
//               ) : !isEnrolled ? (
//                 <div className="space-y-3">
//                   <button
//                     onClick={handleEnroll}
//                     className="w-full flex items-center justify-center space-x-2 py-3 bg-white text-gray-900 rounded-lg font-semibold hover:bg-white/90 transition-colors duration-200"
//                   >
//                     <Play className="w-5 h-5" />
//                     <span>Enroll Now</span>
//                   </button>
//                   <p className="text-xs text-white/70 text-center">
//                     Free enrollment with your {getTierDisplayName(course.tier)} subscription
//                   </p>
//                 </div>
//               ) : (
//                 <div className="space-y-3">
//                   <div className="flex items-center justify-center space-x-2 py-3 bg-green-500 text-white rounded-lg">
//                     <CheckCircle className="w-5 h-5" />
//                     <span className="font-semibold">Enrolled</span>
//                   </div>
                  
//                   {/* Progress Display */}
//                   <div className="bg-white/10 rounded-lg p-3">
//                     <div className="flex justify-between text-sm text-white mb-2">
//                       <span>Your Progress</span>
//                       <span>{progress}%</span>
//                     </div>
//                     <div className="w-full h-2 bg-white/20 rounded-full">
//                       <div 
//                         className="h-2 bg-green-400 rounded-full transition-all duration-300"
//                         style={{ width: `${progress}%` }}
//                       ></div>
//                     </div>
//                     <p className="text-xs text-white/70 text-center mt-2">
//                       {completedCount} of {totalLessons} lessons completed
//                     </p>
//                   </div>

//                   <button
//                     onClick={handleStartCourse}
//                     className="w-full flex items-center justify-center space-x-2 py-3 bg-white text-gray-900 rounded-lg font-semibold hover:bg-white/90 transition-colors duration-200"
//                   >
//                     <Play className="w-5 h-5" />
//                     <span>{progress > 0 ? 'Continue Learning' : 'Start Learning'}</span>
//                   </button>
//                 </div>
//               )}
//             </div>
//           </div>
//         </div>
//       </section>

//       <div className="max-w-7xl mx-auto px-4 sm:px-6 py-8">
//         <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
//           <div className="lg:col-span-2">
//             {/* Learning Objectives */}
//             <div className="bg-white rounded-xl shadow-md p-6">
//               <h2 className="text-2xl font-bold text-gray-900 mb-4 flex items-center space-x-2">
//                 <Target className="w-6 h-6 text-primary" />
//                 <span>What You'll Learn</span>
//               </h2>
//               <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//                 {course.objectives.map((objective, index) => (
//                   <motion.div
//                     key={index}
//                     initial={{ opacity: 0, y: 20 }}
//                     animate={{ opacity: 1, y: 0 }}
//                     transition={{ delay: index * 0.1 }}
//                     className="flex items-start space-x-3"
//                   >
//                     <Zap className="w-5 h-5 text-primary mt-1 flex-shrink-0" />
//                     <span className="text-gray-700">{objective}</span>
//                   </motion.div>
//                 ))}
//               </div>
//             </div>

//             {/* Course Content */}
//             <div className="bg-white rounded-xl shadow-md p-6 mt-6">
//               <div className="flex items-center justify-between mb-6">
//                 <h2 className="text-2xl font-bold text-gray-900">Course Curriculum</h2>
//                 <div className="text-sm text-gray-600">
//                   {totalLessons} lessons • {course.duration}
//                 </div>
//               </div>

//               <div className="space-y-4">
//                 {course.modules.map((module, moduleIndex) => (
//                   <div key={module.id} className="border border-gray-200 rounded-lg overflow-hidden hover:shadow-lg transition-shadow duration-300">
//                     <button
//                       onClick={() => toggleModule(module.id)}
//                       className="w-full flex items-center justify-between p-6 hover:bg-gray-50 transition-colors duration-200 bg-white"
//                     >
//                       <div className="flex items-center space-x-4">
//                         <div className="w-10 h-10 bg-primary/10 text-primary rounded-full flex items-center justify-center font-semibold text-lg">
//                           {moduleIndex + 1}
//                         </div>
//                         <div className="text-left">
//                           <span className="font-semibold text-gray-900 block text-lg">{module.title}</span>
//                           <span className="text-sm text-gray-500">
//                             {module.lessons.length} lessons • {module.lessons.reduce((sum, lesson) => sum + parseInt(lesson.duration), 0)} min
//                           </span>
//                         </div>
//                       </div>
//                       {expandedModules.includes(module.id) ? (
//                         <ChevronUp className="w-5 h-5 text-gray-500" />
//                       ) : (
//                         <ChevronDown className="w-5 h-5 text-gray-500" />
//                       )}
//                     </button>
                    
//                     {expandedModules.includes(module.id) && (
//                       <div className="p-6 bg-gray-50 border-t border-gray-200">
//                         <div className="space-y-3">
//                           {module.lessons.map((lesson, lessonIndex) => {
//                             const isCompleted = courseLessons.includes(lesson.id)
//                             const canAccessLesson = hasAccess && isEnrolled

//                             return (
//                               <motion.div
//                                 key={lesson.id}
//                                 initial={{ opacity: 0 }}
//                                 animate={{ opacity: 1 }}
//                                 transition={{ delay: lessonIndex * 0.05 }}
//                                 className={`flex items-center justify-between p-4 rounded-lg ${
//                                   canAccessLesson ? 'bg-white hover:bg-gray-50 cursor-pointer shadow-sm' : 'bg-gray-100'
//                                 } transition-all duration-200`}
//                                 onClick={() => {
//                                   if (canAccessLesson) {
//                                     navigate(`/learning-path/${getLearningPathIdForCourse()}`)
//                                   }
//                                 }}
//                               >
//                                 <div className="flex items-center space-x-4 flex-1">
//                                   {canAccessLesson ? (
//                                     isCompleted ? (
//                                       <CheckCircle className="w-5 h-5 text-green-500" />
//                                     ) : (
//                                       <div className="w-5 h-5 border-2 border-primary rounded-full flex items-center justify-center">
//                                         <Play className="w-3 h-3 text-primary ml-0.5" />
//                                       </div>
//                                     )
//                                   ) : (
//                                     <Lock className="w-5 h-5 text-gray-400" />
//                                   )}
//                                   <div>
//                                     <span className={
//                                       canAccessLesson 
//                                         ? (isCompleted ? 'text-gray-900 font-medium' : 'text-gray-700')
//                                         : 'text-gray-500'
//                                     }>
//                                       {lesson.title}
//                                     </span>
//                                     {lesson.description && (
//                                       <p className="text-sm text-gray-500 mt-1">{lesson.description}</p>
//                                     )}
//                                   </div>
//                                 </div>
//                                 <div className="flex items-center space-x-4">
//                                   <span className="text-sm text-gray-500 bg-gray-100 px-2 py-1 rounded">{lesson.duration}</span>
//                                   {canAccessLesson && !isCompleted && (
//                                     <button
//                                       onClick={(e) => {
//                                         e.stopPropagation()
//                                         handleLessonComplete(course.id, lesson.id)
//                                       }}
//                                       className="px-3 py-1 bg-primary text-white rounded text-sm font-medium hover:bg-primary/90 transition-colors duration-200"
//                                     >
//                                       Mark Complete
//                                     </button>
//                                   )}
//                                   {canAccessLesson && isCompleted && (
//                                     <span className="px-3 py-1 bg-green-100 text-green-700 rounded text-sm font-medium">
//                                       Completed
//                                     </span>
//                                   )}
//                                   {!canAccessLesson && (
//                                     <Crown className="w-4 h-4 text-gray-400" />
//                                   )}
//                                 </div>
//                               </motion.div>
//                             )
//                           })}
//                         </div>
//                       </div>
//                     )}
//                   </div>
//                 ))}
//               </div>

//               {/* Access Required Message */}
//               {!hasAccess && (
//                 <motion.div
//                   initial={{ opacity: 0, y: 20 }}
//                   animate={{ opacity: 1, y: 0 }}
//                   className="mt-6 p-6 bg-gradient-to-r from-primary to-accent rounded-lg text-white"
//                 >
//                   <div className="flex items-center space-x-4">
//                     <Crown className="w-8 h-8" />
//                     <div>
//                       <h3 className="font-semibold text-lg">Upgrade Required</h3>
//                       <p className="text-sm opacity-90 mt-1">
//                         This course requires {getTierDisplayName(course.tier)}. Upgrade your subscription to unlock all {totalLessons} lessons and start learning.
//                       </p>
//                     </div>
//                   </div>
//                 </motion.div>
//               )}
//             </div>

//             {/* Podcast Inspiration Section */}
//             {relatedPodcast && (
//               <motion.div
//                 initial={{ opacity: 0, y: 20 }}
//                 animate={{ opacity: 1, y: 0 }}
//                 transition={{ delay: 0.3 }}
//                 className="bg-gradient-to-br from-purple-500 to-pink-600 rounded-xl p-6 text-white mt-6"
//               >
//                 <div className="flex items-center space-x-3 mb-4">
//                   <Sparkles className="w-6 h-6 text-yellow-300" />
//                   <h2 className="text-2xl font-bold">Inspired by Podcast</h2>
//                 </div>
//                 <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 items-center">
//                   <div>
//                     <h3 className="text-xl font-bold mb-2">{relatedPodcast.title}</h3>
//                     <p className="text-purple-100 mb-4">{relatedPodcast.summary}</p>
//                     <div className="flex items-center space-x-4 text-sm text-purple-200 mb-4">
//                       <div className="flex items-center space-x-1">
//                         <Clock className="w-4 h-4" />
//                         <span>{relatedPodcast.duration}</span>
//                       </div>
//                       <div className="flex items-center space-x-1">
//                         <Mic className="w-4 h-4" />
//                         <span>{relatedPodcast.episodeType}</span>
//                       </div>
//                       <div className="flex items-center space-x-1">
//                         <Headphones className="w-4 h-4" />
//                         <span>{relatedPodcast.listens} listens</span>
//                       </div>
//                     </div>
//                     <div className="flex space-x-3">
//                       <button
//                         onClick={handlePlayPodcast}
//                         className="flex items-center space-x-2 px-6 py-3 bg-white text-purple-600 rounded-lg font-semibold hover:bg-gray-100 transition-colors duration-200"
//                       >
//                         <Play className="w-5 h-5" />
//                         <span>Listen Now</span>
//                       </button>
//                       <button className="flex items-center space-x-2 px-4 py-3 bg-white/20 backdrop-blur-sm rounded-lg hover:bg-white/30 transition-colors duration-200">
//                         <Download className="w-5 h-5" />
//                         <span>Download</span>
//                       </button>
//                     </div>
//                   </div>
//                   <div className="flex justify-center">
//                     <div className="w-32 h-32 bg-white/20 rounded-xl flex items-center justify-center">
//                       <Headphones className="w-12 h-12 text-white" />
//                     </div>
//                   </div>
//                 </div>
//               </motion.div>
//             )}

//             {/* Community Discussion */}
//             <div className="bg-white rounded-xl shadow-md p-6 mt-6">
//               <div className="flex items-center space-x-3 mb-4">
//                 <MessageCircle className="w-6 h-6 text-primary" />
//                 <h2 className="text-2xl font-bold text-gray-900">Join the Discussion</h2>
//               </div>
//               <p className="text-gray-600 mb-4">
//                 Connect with fellow learners, ask questions, and share your progress in our community.
//               </p>
//               <div className="flex space-x-3">
//                 <button className="inline-flex items-center space-x-2 px-6 py-3 bg-indigo-600 text-white rounded-lg font-medium hover:bg-indigo-700 transition-colors duration-200">
//                   <MessageCircle className="w-5 h-5" />
//                   <span>Join Discord</span>
//                 </button>
//                 <button className="inline-flex items-center space-x-2 px-6 py-3 bg-gray-100 text-gray-700 rounded-lg font-medium hover:bg-gray-200 transition-colors duration-200">
//                   <Share2 className="w-5 h-5" />
//                   <span>Share Course</span>
//                 </button>
//               </div>
//             </div>
//           </div>

//           {/* Sidebar */}
//           <div className="lg:col-span-1 space-y-6">
//             {isEnrolled && <ProgressTracker courseId={course.id} modules={course.modules} />}
            
//             {/* Course Stats */}
//             <div className="bg-white rounded-xl shadow-md p-6">
//               <h3 className="text-lg font-bold text-gray-900 mb-4 flex items-center space-x-2">
//                 <BarChart3 className="w-5 h-5 text-primary" />
//                 <span>Course Details</span>
//               </h3>
//               <div className="space-y-3">
//                 <div className="flex justify-between">
//                   <span className="text-gray-600">Skill Level</span>
//                   <span className="font-medium text-gray-900">{course.skillLevel}</span>
//                 </div>
//                 <div className="flex justify-between">
//                   <span className="text-gray-600">Total Lessons</span>
//                   <span className="font-medium text-gray-900">{totalLessons}</span>
//                 </div>
//                 <div className="flex justify-between">
//                   <span className="text-gray-600">Duration</span>
//                   <span className="font-medium text-gray-900">{course.duration}</span>
//                 </div>
//                 <div className="flex justify-between">
//                   <span className="text-gray-600">Certificate</span>
//                   <span className="font-medium text-gray-900">
//                     {course.hasCertificate ? 'Included' : 'Not Included'}
//                   </span>
//                 </div>
//                 <div className="flex justify-between">
//                   <span className="text-gray-600">Students</span>
//                   <span className="font-medium text-gray-900">{course.students.toLocaleString()}</span>
//                 </div>
//                 <div className="flex justify-between">
//                   <span className="text-gray-600">Rating</span>
//                   <span className="font-medium text-gray-900 flex items-center">
//                     <Star className="w-4 h-4 text-yellow-400 fill-current mr-1" />
//                     {course.rating}
//                   </span>
//                 </div>
//               </div>
//             </div>

//             {/* Topics Covered */}
//             <div className="bg-white rounded-xl shadow-md p-6">
//               <h3 className="text-lg font-bold text-gray-900 mb-4">Topics Covered</h3>
//               <div className="flex flex-wrap gap-2">
//                 {course.topics.map((topic, index) => (
//                   <span
//                     key={index}
//                     className="px-3 py-1 bg-primary/10 text-primary text-sm rounded-full"
//                   >
//                     {topic}
//                   </span>
//                 ))}
//               </div>
//             </div>

//             {/* Instructor Info */}
//             <div className="bg-white rounded-xl shadow-md p-6">
//               <h3 className="text-lg font-bold text-gray-900 mb-4">About the Instructor</h3>
//               <div className="flex items-center space-x-3 mb-3">
//                 <div className="w-12 h-12 bg-gradient-to-br from-primary to-accent rounded-full flex items-center justify-center text-white font-bold">
//                   AI
//                 </div>
//                 <div>
//                   <div className="font-semibold text-gray-900">Saints Academy AI</div>
//                   <div className="text-sm text-gray-600">AI-Powered Instructor</div>
//                 </div>
//               </div>
//               <p className="text-gray-600 text-sm">
//                 This course was generated using advanced AI technology, combining the latest research and best practices in {course.category.toLowerCase()}.
//               </p>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   )
// }

// export default CourseDetail

import { motion } from 'framer-motion'
import { Clock, Award, Lock, BookOpen, Users, Star, Play, AlertCircle, Mail, Target, Zap, Sparkles, Headphones } from 'lucide-react'
import { useNavigate } from 'react-router-dom'
import { useState } from 'react'

function CourseDetail() {
  const navigate = useNavigate()
  const [email, setEmail] = useState('')
  const [subscribed, setSubscribed] = useState(false)
  const [loading, setLoading] = useState(false)
  const [selectedCourseType, setSelectedCourseType] = useState('specific') // 'specific' or 'general'

  // Mock course data for display
  const course = {
    id: 101,
    title: 'Introduction to Artificial Intelligence',
    description: 'Learn the fundamentals of AI, machine learning, and neural networks from scratch.',
    category: 'Technology & AI',
    skillLevel: 'Beginner',
    duration: '8 weeks',
    modules: [
      { id: 1, title: 'AI Fundamentals', lessons: [] },
      { id: 2, title: 'Machine Learning Basics', lessons: [] },
      { id: 3, title: 'Neural Networks', lessons: [] }
    ],
    students: 2500,
    rating: 4.8,
    tier: 'plus',
    hasCertificate: true,
    topics: ['AI', 'Machine Learning', 'Neural Networks', 'Deep Learning', 'Python'],
    objectives: [
      'Understand AI fundamentals and concepts',
      'Build basic machine learning models',
      'Implement neural networks',
      'Apply AI to real-world problems'
    ]
  }

  const handleNotifyMe = async (e) => {
  e.preventDefault();
  if (!email) return;

  setLoading(true);
  
  try {
    const token = localStorage.getItem('token');
    const user = JSON.parse(localStorage.getItem('user') || 'null');
    
    const response = await fetch('/v2/admin/email-api', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': token ? `Bearer ${token}` : '',
      },
      body: JSON.stringify({
        action: 'subscribe',
        email: email,
        type: selectedCourseType === 'specific' ? 'course_launch' : 'all_courses_launch',
        source: 'course_detail_page',
        tier: course.tier,
        user_id: user?.id || null,
        name: user?.name || null,
        meta: {
          course_id: selectedCourseType === 'specific' ? course.id : null,
          course_title: selectedCourseType === 'specific' ? course.title : null,
          course_category: course.category,
          course_tier: course.tier,
          notification_for: selectedCourseType === 'specific' ? 'specific_course' : 'all_courses',
          source_page: 'course_detail',
          notification_type: selectedCourseType,
          timestamp: new Date().toISOString()
        }
      })
    });

    const data = await response.json();
    
    if (data.success) {
      setSubscribed(true);
      setEmail('');
      
      setTimeout(() => {
        setSubscribed(false);
      }, 5000);
    } else {
      alert(data.error || 'Failed to subscribe to course notifications');
    }
  } catch (error) {
    console.error('Notification error:', error);
    alert('Failed to subscribe. Please try again later.');
  } finally {
    setLoading(false);
  }
};

  const handleGoToPodcasts = () => {
    navigate('/podcasts')
  }

  const getNotificationMessage = () => {
    if (selectedCourseType === 'specific') {
      return `You'll be notified when "${course.title}" launches. We'll send you an email with enrollment details.`;
    } else {
      return 'You\'ll be notified when all courses in Learning Hub launch, including this course and others in development.';
    }
  }

  return (
    <div className="min-h-screen bg-gray-50 py-12">
      <div className="max-w-4xl mx-auto px-4 sm:px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-center mb-12"
        >
          {/* Back to LearningHub Button */}
          <button
            onClick={() => navigate('/courses')}
            className="flex items-center space-x-2 text-primary hover:text-primary/80 mb-8"
          >
            <span>← Back to Learning Hub</span>
          </button>

          {/* Hero Card */}
          <div className="bg-gradient-to-br from-primary to-accent rounded-2xl p-8 md:p-12 text-white mb-8">
            <div className="flex items-center justify-center gap-3 mb-6">
              <BookOpen className="w-10 h-10" />
              <h1 className="text-4xl md:text-5xl font-bold">Course Details</h1>
            </div>
            
            <div className="mb-8">
              <div className="inline-flex items-center gap-2 bg-white/30 backdrop-blur-sm px-6 py-3 rounded-full mb-4">
                <AlertCircle className="w-6 h-6" />
                <span className="text-lg font-semibold">Coming Soon</span>
              </div>
              <p className="text-xl text-purple-100 mb-6 max-w-2xl mx-auto">
                Courses are currently under development. We're building comprehensive learning experiences with structured curriculum, projects, and certificates.
              </p>
            </div>

            <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
              <div className="bg-white/20 backdrop-blur-sm rounded-xl p-4 text-center">
                <div className="flex items-center justify-center mb-2">
                  <Target className="w-6 h-6" />
                </div>
                <p className="text-2xl font-bold">25+</p>
                <p className="text-sm text-purple-100">Courses Planned</p>
              </div>
              <div className="bg-white/20 backdrop-blur-sm rounded-xl p-4 text-center">
                <div className="flex items-center justify-center mb-2">
                  <Clock className="w-6 h-6" />
                </div>
                <p className="text-2xl font-bold">100+</p>
                <p className="text-sm text-purple-100">Hours Content</p>
              </div>
              <div className="bg-white/20 backdrop-blur-sm rounded-xl p-4 text-center">
                <div className="flex items-center justify-center mb-2">
                  <Award className="w-6 h-6" />
                </div>
                <p className="text-2xl font-bold">✓</p>
                <p className="text-sm text-purple-100">Certificates</p>
              </div>
              <div className="bg-white/20 backdrop-blur-sm rounded-xl p-4 text-center">
                <div className="flex items-center justify-center mb-2">
                  <Zap className="w-6 h-6" />
                </div>
                <p className="text-2xl font-bold">AI</p>
                <p className="text-sm text-purple-100">Powered</p>
              </div>
            </div>
          </div>
        </motion.div>

        {/* Course Preview Section */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.1 }}
          className="bg-white rounded-2xl shadow-xl p-8 mb-8"
        >
          <div className="flex items-center gap-3 mb-6">
            <div className="w-12 h-12 bg-gradient-to-br from-primary to-accent rounded-lg flex items-center justify-center">
              <BookOpen className="w-6 h-6 text-white" />
            </div>
            <div>
              <h2 className="text-2xl font-bold text-gray-900">{course.title}</h2>
              <div className="flex items-center gap-2 mt-1">
                <span className="px-2 py-1 bg-primary/10 text-primary text-xs font-medium rounded">
                  {course.category}
                </span>
                <span className="px-2 py-1 bg-green-100 text-green-800 text-xs font-medium rounded">
                  {course.skillLevel}
                </span>
                <span className="px-2 py-1 bg-purple-100 text-purple-800 text-xs font-medium rounded">
                  Saints {course.tier}
                </span>
              </div>
            </div>
          </div>

          <p className="text-gray-600 mb-6">{course.description}</p>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-6">
            <div className="text-center p-3 bg-gray-50 rounded-lg">
              <Clock className="w-5 h-5 text-gray-500 mx-auto mb-1" />
              <p className="text-sm text-gray-600">Duration</p>
              <p className="font-semibold text-gray-900">{course.duration}</p>
            </div>
            <div className="text-center p-3 bg-gray-50 rounded-lg">
              <BookOpen className="w-5 h-5 text-gray-500 mx-auto mb-1" />
              <p className="text-sm text-gray-600">Modules</p>
              <p className="font-semibold text-gray-900">{course.modules.length}</p>
            </div>
            <div className="text-center p-3 bg-gray-50 rounded-lg">
              <Users className="w-5 h-5 text-gray-500 mx-auto mb-1" />
              <p className="text-sm text-gray-600">Students</p>
              <p className="font-semibold text-gray-900">{course.students.toLocaleString()}</p>
            </div>
            <div className="text-center p-3 bg-gray-50 rounded-lg">
              <Star className="w-5 h-5 text-yellow-500 mx-auto mb-1 fill-current" />
              <p className="text-sm text-gray-600">Rating</p>
              <p className="font-semibold text-gray-900">{course.rating}</p>
            </div>
          </div>

          {/* Learning Objectives */}
          <div className="mb-6">
            <h3 className="text-lg font-bold text-gray-900 mb-3 flex items-center gap-2">
              <Target className="w-5 h-5 text-primary" />
              What You'll Learn
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
              {course.objectives.map((objective, index) => (
                <div key={index} className="flex items-start gap-2">
                  <Zap className="w-4 h-4 text-primary mt-1 flex-shrink-0" />
                  <span className="text-gray-700 text-sm">{objective}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Topics Covered */}
          <div className="mb-6">
            <h3 className="text-lg font-bold text-gray-900 mb-3">Topics Covered</h3>
            <div className="flex flex-wrap gap-2">
              {course.topics.map((topic, index) => (
                <span
                  key={index}
                  className="px-3 py-1 bg-primary/10 text-primary text-sm rounded-full"
                >
                  {topic}
                </span>
              ))}
            </div>
          </div>
        </motion.div>

        {/* Coming Soon Content */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2 }}
          className="bg-white rounded-2xl shadow-xl p-8 md:p-12 mb-8"
        >
          <div className="text-center max-w-2xl mx-auto">
            <div className="w-24 h-24 bg-gradient-to-br from-primary/10 to-accent/10 rounded-full flex items-center justify-center mx-auto mb-6">
              <AlertCircle className="w-12 h-12 text-primary" />
            </div>
            
            <h2 className="text-3xl font-bold text-gray-900 mb-4">
              Courses Are Coming Soon
            </h2>
            
            <p className="text-gray-600 text-lg mb-8">
              We're currently developing a comprehensive course catalog with structured learning paths, interactive content, and AI-powered assessments. Each course will include:
            </p>

            {/* Course Features */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
              <div className="flex items-start space-x-3">
                <div className="w-10 h-10 bg-blue-100 rounded-lg flex items-center justify-center flex-shrink-0">
                  <BookOpen className="w-5 h-5 text-blue-600" />
                </div>
                <div>
                  <h3 className="font-bold text-gray-900 mb-1">Structured Curriculum</h3>
                  <p className="text-gray-600 text-sm">Progress from beginner to advanced with clear learning objectives</p>
                </div>
              </div>
              <div className="flex items-start space-x-3">
                <div className="w-10 h-10 bg-green-100 rounded-lg flex items-center justify-center flex-shrink-0">
                  <Target className="w-5 h-5 text-green-600" />
                </div>
                <div>
                  <h3 className="font-bold text-gray-900 mb-1">Hands-on Projects</h3>
                  <p className="text-gray-600 text-sm">Apply what you learn with practical, real-world projects</p>
                </div>
              </div>
              <div className="flex items-start space-x-3">
                <div className="w-10 h-10 bg-purple-100 rounded-lg flex items-center justify-center flex-shrink-0">
                  <Award className="w-5 h-5 text-purple-600" />
                </div>
                <div>
                  <h3 className="font-bold text-gray-900 mb-1">Certification</h3>
                  <p className="text-gray-600 text-sm">Earn verifiable certificates upon completion</p>
                </div>
              </div>
              <div className="flex items-start space-x-3">
                <div className="w-10 h-10 bg-yellow-100 rounded-lg flex items-center justify-center flex-shrink-0">
                  <Zap className="w-5 h-5 text-yellow-600" />
                </div>
                <div>
                  <h3 className="font-bold text-gray-900 mb-1">AI-Powered Learning</h3>
                  <p className="text-gray-600 text-sm">Personalized learning paths with AI assistance</p>
                </div>
              </div>
            </div>

            {/* Email Notification Form */}
            <div className="bg-gradient-to-br from-primary/5 to-accent/5 rounded-xl p-6">
              <h3 className="text-xl font-bold text-gray-900 mb-4 flex items-center justify-center gap-2">
                <Mail className="w-5 h-5" />
                Get Early Access to Courses
              </h3>
              
              {subscribed ? (
                <div className="bg-green-50 text-green-700 p-4 rounded-lg">
                  <p className="font-medium">🎉 Thank you! We'll notify you when courses launch.</p>
                  <p className="text-sm mt-1">{getNotificationMessage()}</p>
                </div>
              ) : (
                <>
                  {/* Notification Type Selection */}
                  <div className="flex border border-gray-300 rounded-lg overflow-hidden mb-4">
                    <button
                      type="button"
                      onClick={() => setSelectedCourseType('specific')}
                      className={`flex-1 py-2 text-sm font-medium ${
                        selectedCourseType === 'specific'
                          ? 'bg-primary text-white'
                          : 'bg-white text-gray-700 hover:bg-gray-50'
                      }`}
                    >
                      This Course Only
                    </button>
                    <button
                      type="button"
                      onClick={() => setSelectedCourseType('general')}
                      className={`flex-1 py-2 text-sm font-medium ${
                        selectedCourseType === 'general'
                          ? 'bg-primary text-white'
                          : 'bg-white text-gray-700 hover:bg-gray-50'
                      }`}
                    >
                      All Courses
                    </button>
                  </div>
                  
                  <form onSubmit={handleNotifyMe} className="flex flex-col sm:flex-row gap-3">
                    <input
                      type="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      placeholder="Enter your email"
                      className="flex-1 px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent"
                      required
                    />
                    <button
                      type="submit"
                      disabled={loading}
                      className="px-6 py-3 bg-primary text-white rounded-lg font-semibold hover:bg-primary/90 transition-colors duration-200 disabled:opacity-50 disabled:cursor-not-allowed"
                    >
                      {loading ? (
                        <span className="flex items-center justify-center">
                          <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin mr-2"></div>
                          Submitting...
                        </span>
                      ) : (
                        'Notify Me'
                      )}
                    </button>
                  </form>
                  
                  <p className="text-gray-500 text-sm mt-4 text-center">
                    {selectedCourseType === 'specific'
                      ? `We'll send you early access to "${course.title}" when it launches.`
                      : 'We\'ll notify you when all courses in Learning Hub launch.'}
                  </p>
                </>
              )}
            </div>
          </div>
        </motion.div>

        {/* Current Learning Options */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.4 }}
          className="bg-white rounded-2xl shadow-xl p-8"
        >
          <h2 className="text-2xl font-bold text-gray-900 mb-6 text-center">Start Learning Now</h2>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="bg-gradient-to-br from-blue-50 to-blue-100 rounded-xl p-6">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-12 h-12 bg-blue-500 text-white rounded-lg flex items-center justify-center">
                  <Users className="w-6 h-6" />
                </div>
                <div>
                  <h3 className="font-bold text-gray-900">Join Ambassador Program</h3>
                  <p className="text-gray-600 text-sm">Access premium content and earn rewards</p>
                </div>
              </div>
              <button
                onClick={() => navigate('/ambassador-program')}
                className="w-full py-3 bg-blue-500 text-white rounded-lg font-medium hover:bg-blue-600 transition-colors duration-200"
              >
                Apply Now
              </button>
            </div>

            <div className="bg-gradient-to-br from-purple-50 to-purple-100 rounded-xl p-6">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-12 h-12 bg-purple-500 text-white rounded-lg flex items-center justify-center">
                  <Headphones className="w-6 h-6" />
                </div>
                <div>
                  <h3 className="font-bold text-gray-900">Explore Podcasts</h3>
                  <p className="text-gray-600 text-sm">AI-generated episodes on trending topics</p>
                </div>
              </div>
              <button
                onClick={handleGoToPodcasts}
                className="w-full py-3 bg-purple-500 text-white rounded-lg font-medium hover:bg-purple-600 transition-colors duration-200"
              >
                Listen Now
              </button>
            </div>
          </div>
        </motion.div>
      </div>
    </div>
  )
}

export default CourseDetail